var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 4.2H11.2V5.4H12.4V3.6C12.4 3.44087 12.3368 3.28826 12.2243 3.17574C12.1117 3.06321 11.9591 3 11.8 3H4.6C4.44087 3 4.28826 3.06321 4.17574 3.17574C4.06321 3.28826 4 3.44087 4 3.6V5.4H5.2V4.2H7.6V11.8H6V13H10.4V11.8H8.8V4.2Z",
    fill: "#137a83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.d4fc52c9351fbd36cd396e5d8b0d7f08.svg";
export { ForwardRef as ReactComponent };